import React from 'react';
import { NextPage } from 'next';
import LoginLayout from '../components/layout/login/LoginLayout';
import AccountRecoveryPage from '../containers/AccountRecoveryPage';

const AccountRecovery: NextPage = () => (
  <LoginLayout title="Account Recovery">
    <AccountRecoveryPage></AccountRecoveryPage>
  </LoginLayout>
);

export default AccountRecovery;
